import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './BillCardLoading.config.style';

const billCardLoadingConfig = [
  {
    left: setLoadingConfigObject('square', 1, null, styles.year),
    right: setLoadingConfigObject('square', 1, null, styles.status),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.month),
    right: setLoadingConfigObject('square', 1, null, styles.price),
  },
  {
    main: setLoadingConfigObject('line', 1, null, styles.line),
  },
  {
    left: ['row', setLoadingConfigObject('circle', 4, 30, styles.serviceIcon)],
    right: setLoadingConfigObject('circle', 1, 30, styles.arrow),
  },
];

export { billCardLoadingConfig }; // eslint-disable-line import/prefer-default-export
